import styled from 'styled-components';

import { Tooltip } from '@sternum/ui';

export const TooltipStyled = styled(Tooltip)`
  width: 300px;
`;
